import { createApiInstance } from './ApiConfig';

// Create axios instance with base configuration
const api = createApiInstance();

// Contract with the hub firmware: the command is gnss_fw_{gnssType}_{version}
// and the hub splits on the first '_' after the prefix, so the type has no
// underscore. Keep in sync with backend/src/terna_hub/api/gnss_ota.py.
export const GNSS_TYPE_PATTERN = /^[A-Za-z0-9]{1,23}$/;
export const GNSS_VERSION_PATTERN = /^[A-Za-z0-9._-]{1,47}$/;
export const KNOWN_GNSS_TYPES = ['Septentrio', 'Unicorecomm'];

export const buildGnssUpgradeCommand = (gnssType, version) => `gnss_fw_${gnssType}_${version}`;

// Firmware File Management APIs

// gnssType is optional; the backend filter is case-insensitive
export const listGnssFirmwares = async gnssType => {
  return api.get('/gnss/ota/firmwares', {
    params: gnssType ? { gnss_type: gnssType } : {},
  });
};

export const uploadGnssFirmware = async (
  file,
  { gnssType, version, comment },
  onUploadProgress
) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('gnss_type', gnssType);
  formData.append('version', version);
  if (comment) {
    formData.append('comment', comment);
  }

  return api.post('/gnss/ota/firmwares/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    onUploadProgress,
  });
};

export const deleteGnssFirmware = async id => {
  return api.delete(`/gnss/ota/firmwares/${encodeURIComponent(id)}`);
};

// Binary download (same endpoint the hub streams into the GNSS receiver)

export const downloadGnssFirmwareBinary = async (gnssType, version) => {
  return api.get('/gnss/ota/get_firmware_binary', {
    params: { gnss_type: gnssType, version },
    responseType: 'blob',
  });
};
